module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-turntable"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.truntable.activityBackground,
      "alt": ""
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "warp"
  }, [_c('img', {
    attrs: {
      "src": _vm.truntable.couponPicture,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("优惠券已经存入卡包请进APP进行使用")]), _vm._v(" "), _c('div', {
    staticClass: "reprintBtn",
    style: (_vm.styleButton),
    on: {
      "click": function($event) {
        return _vm.$router.push("/download")
      }
    }
  }, [_vm._v("立即使用")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb37db1a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activityTurntableAfterReceive.vue
// module id = 330
// module chunks = 1